import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { endingViewpoints } from "@/mocks/ending";

export default function Ending() {
  return (
    <section id="ending" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="结局讨论"
            title="关于结局，大家都在争论什么"
            desc="围绕结局的讨论长期存在，但并非所有问题都同等程度地「有定论」。下面把常见疑问整理出来，并标明哪些属于作品已交代的内容，哪些属于观众解读。"
          />
        </Reveal>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {endingViewpoints.map((item, index) => (
            <Reveal key={item.id} delay={(index % 3) * 90}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                <div className="flex items-center justify-between gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className={`${item.icon} text-xl`} />
                  </span>
                  <span className="rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">{item.status}</span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 md:text-lg">{item.title}</h3>
                <p className="mt-2.5 flex-1 text-sm leading-7 text-foreground-700">{item.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-8 rounded-lg border border-background-200 bg-secondary-100 p-5 md:p-6">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-secondary-900">
              <i className="ri-error-warning-line" />
              一点说明
            </h3>
            <p className="mt-3 text-sm leading-7 text-secondary-900/85">
              本站的讨论基于作品已经呈现的内容，并尽量区分「剧情给出的信息」与「观众的延伸推测」。对于作品没有明确交代的部分，这里只做一般性说明，不会把推测当成既定事实。如果你有不同看法，也完全正常——围绕结局的多元解读，本身就是这类作品的一部分。
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}